import { z } from 'zod'

export const updatePermissionRequestSchema = z.object({
  /** 企業帳號 */
  account: z.string(),
  /** 權限
   * 有效 - true
   * 停權 - false
   */
  permission: z.boolean()
})

export interface UpdatePermissionRequest
  extends z.infer<typeof updatePermissionRequestSchema> {}
